var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretUpOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.756344 5.25L7.99259 5.25C8.66525 5.25 9.00131 4.43598 8.52689 3.96156L4.90384 0.220937C4.75947 0.0738275 4.58994 1.13249e-07 4.37392 9.43643e-08C4.18107 7.75044e-08 3.98783 0.07391 3.8399 0.22173L0.222321 3.96235C-0.25264 4.43516 0.083688 5.25 0.756344 5.25Z",
    fill: "#009DE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUpOutlined);
export default __webpack_public_path__ + "static/media/caretUpOutlined.efe25a7a87b38682e181a9b6b79568d1.svg";
export { ForwardRef as ReactComponent };